// extracted by mini-css-extract-plugin
export default {"contentWrap":"styles_contentWrap__N+v8V","backButton":"styles_backButton__KnKJF"};